/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ReactIconProps } from '../../../types/iconsTypes';

export function ErrorIcon(props: ReactIconProps) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M22.3335 11.334C22.3335 17.4091 17.4086 22.334 11.3335 22.334C5.25836 22.334 0.333496 17.4091 0.333496 11.334C0.333496 5.25885 5.25836 0.333984 11.3335 0.333984C17.4086 0.333984 22.3335 5.25885 22.3335 11.334ZM8.00009 8.0006C8.32227 7.67842 8.84463 7.67842 9.16681 8.0006L11.3335 10.1672L13.5001 8.00062C13.8223 7.67844 14.3446 7.67844 14.6668 8.00062C14.989 8.3228 14.989 8.84517 14.6668 9.16735L12.5002 11.334L14.6668 13.5006C14.989 13.8228 14.989 14.3451 14.6668 14.6673C14.3446 14.9895 13.8222 14.9895 13.5001 14.6673L11.3335 12.5007L9.16684 14.6673C8.84465 14.9895 8.32229 14.9895 8.00011 14.6673C7.67793 14.3451 7.67793 13.8228 8.00011 13.5006L10.1667 11.334L8.00009 9.16733C7.6779 8.84514 7.6779 8.32278 8.00009 8.0006Z" fill="#D9534F" />
    </svg>
  );
}

export function CheckIcon(props: ReactIconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM15.4334 7.66664C15.7555 7.98882 15.7555 8.51118 15.4334 8.83336L9.93336 14.3334C9.61118 14.6555 9.08882 14.6555 8.76664 14.3334L6.56664 12.1334C6.24445 11.8112 6.24445 11.2888 6.56664 10.9666C6.88882 10.6445 7.41118 10.6445 7.73336 10.9666L9.35 12.5833L11.8083 10.125L14.2666 7.66664C14.5888 7.34445 15.1112 7.34445 15.4334 7.66664Z"
        fill="#5CB85C"
      />
    </svg>
  );
}
